
import Loader from "react-loader-spinner";
import { useEffect, useReducer, useRef, useState } from "react";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings, productSerialTurnoverInStorage } from "../store/api/Invoice";
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import BihamtaTable from "../../Components/BihamtaTable";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DatePicker from "react-datepicker2";

export default function ProductSerialTurnoverInStorage() {
    const dispatch = useDispatch();
    const filterData = useRef({ Skip: 0, Take: 10 });
    const history = useHistory();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [popProduct, setPopProduct] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
    const { settings } = useSelector(state => { return { settings: state.InvoiceReducer.systemSettings } });
    const pgType = Array.isArray(settings ?? "") ? Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue ?? 1) : 1;
    const pDefaultSalePrice = Array.isArray(settings) ? settings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
    const pDefaultSalePriceLabel = Array.isArray(settings) ? settings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "ProductHolder", colTitle: "مارک کالا", showInMobile: true, showCondition: () => Number(pgType) !== 1 },
        { colName: "ProductName", colTitle: (Number(pgType) !== 1 ? "نوع کالا" : "نام کالا"), showInMobile: true },
        { colName: "ProductModel", colTitle: "مدل کالا", showInMobile: true },
        { colName: "ProductSerial", colTitle: "سریال کالا", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colName: "UnitPrice", colTitle: "قیمت واحد", colType: "currency" },
        { colName: "InvoiceTypeName", colTitle: "نوع فاکتور" },
        { colName: "PContactDate", colTitle: "تاریخ فاکتور" },
        { colName: "InvoiceNumber", colTitle: "شماره فاکتور" }
    ]
    function showModalProduct(e) {
        if (e.key) {
            if (e.key === "Enter" || e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        filterData.current.ProductID = null;
        filterData.current.ProductName = null;

        const setData = (data) => {
            if (data) {
                data.ProductName += '- ' + data.ProductModel;
                if (pgType !== 1) {
                    data.ProductName = data.HolderName + "- " + data.ProductName;
                }
            }
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, forStorageReport: true });
    }
    function toExcel() {
        const url = "api/InvoiceAPI/ProductSerialTurnoverInStorage";
        const searchArgs = { ...filterData.current };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("ProductSerialTurnoverInStorage", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/ProductSerialTurnoverInStorage/${e.ctrlKey}`,
            state: {
                dataUrl: "api/InvoiceAPI/ProductSerialTurnoverInStorage",
                method: "post",
                fetchBody:JSON.stringify({ ...filterData.current, Skip:0, Take:0 })
            }
        });
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search() {
        filterData.current.ProductID = selectedProduct?.ProductID;
        filterData.current.Skip = 0;
        const pContactDateFrom = document.getElementsByName("ContactDateFrom")[0]?.value;
        if (pContactDateFrom === "") {
            delete filterData.current.ContactDateFrom;
        }
        else{
            filterData.current.PContactDateFrom = pContactDateFrom;
        }
        const pContactDateTo = document.getElementsByName("ContactDateTo")[0]?.value;
        if (pContactDateTo === "") {
            delete filterData.current.ContactDateTo;
        }
        else{
            filterData.current.PContactDateTo = pContactDateTo;
        }
        dispatch(productSerialTurnoverInStorage(filterData.current));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-فروش و انبار";
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-2" id="InvoiceContainer">
            <br />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} hideNewProduct={true}
                defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
            <Card>
                <Card.Header className="headerStyle">گردش سریال کالاهای انبار</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Row id="divFilters" className="rowBorder">
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <Col md={2} className="form-group">
                            <label>سریال کالا:</label>
                            <Form.Control onChange={e => filterData.current.ProductSerial = e.target.value} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>مشخصات کالا:</label>
                            <Form.Control readOnly onKeyDown={showModalProduct} name="ProductName"
                                value={selectedProduct?.ProductName ?? filterData.current?.ProductName ?? ""} />
                            <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 26 }}><List size={23} /></Button>
                        </Col>
                        <Col md={1} className="form-group">
                            <label className="ellipsisLabel" title="تاریخ فاکتور از">تاریخ فاکتور از:</label>
                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom"
                                onChange={value => filterData.current.ContactDateFrom = value.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={1} className="form-group">
                            <label className="ellipsisLabel" title="تاریخ فاکتور تا">تاریخ فاکتور تا:</label>
                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo"
                                onChange={val => filterData.current.ContactDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>

                        <Col md={1} className="form-group">
                            <label className="ellipsisLabel" title="تعداد در صفحه">تعداد در صفحه:</label>
                            <select className="form-control" onChange={e => filterData.current.Take = e.target.value}>
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={500}>500</option>
                                <option value={1000}>1000</option>
                            </select>
                        </Col>
                    </Row>
                    <div>
                        <Button className="group-Btn-large mt-1" variant="secondary" onClick={search}><Search size={18} />&nbsp;نمایش گزارش </Button>
                    </div>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <Printer onClick={print} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>
                    }
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} columns={tableCols} filterData={filterData.current} searchMethod={(data) => dispatch(productSerialTurnoverInStorage(data))}
                        reducerName="InvoiceReducer" objectName="pSerialTurnInStorage" style={{ whiteSpace: "nowrap" }} className="mt-0 mb-0" maxHeight={500} />
                </Card.Body>
            </Card>
        </div>
    )
}